import { config } from '@iheartjane/config';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@jane/shared/data-access';

interface DevUserSession {
  authenticated: boolean;
  email: string;
  expires_at: Date;
  kiosk_id: string;
  user_id: string;
}

const devUserSessionUrl = () =>
  `${config.apiPathBase}/controls/kiosk/device_grant_sessions`;

const createDevUserSession = (data: {
  email?: string | undefined;
  password?: string | undefined;
}) => api.put<DevUserSession>(devUserSessionUrl(), data);

export const useCreateDevUserSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createDevUserSession,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['kiosk', 'user'],
      });
    },
  });
};
